import React, { useEffect, useState } from 'react';
import { GENERATE_OTP_ATTEMPTS_ALLOWED } from '../../utils/constants';
import { allowOnlyNumbers } from '../../utils/helperFunctions';
import { TextField } from '@material-ui/core';
import { Button } from 'unified-ui-components-library';
import { getApiData } from '../../api/api';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import AxiosRequest from '../../utils/axios';

const axios = new AxiosRequest().getClient()

const SDOtp = ({ setShowOtpPage, jwtToken, setJwtToken, proposalNo }) => {
    const [countdown, setCountdown] = useState(59);
    const [startCountdown, setStartCountdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpSentMsg, setOtpSentMsg] = useState('');
    const [otp, setOtp] = useState('');
    const [sendOtpError, setSendOtpError] = useState('');
    const [verifyOtpError, setVerifyOtpError] = useState('');
    const [otpSentCount, setOtpSentCount] = useState(0);

    useEffect(() => {
        getOtp();
    }, [])

    useEffect(() => {
        setVerifyOtpError('')
    },[otp])

    useEffect(() => {
        if (!startCountdown) {
            return;
        }
        const timer = setInterval(() => {
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [startCountdown]);

    const getOtp = async () => {
        setSendOtpError('');
        setLoading(true);
        const { url, body } = getApiData("getOtp");
        body.request.payload.isSdLink = "Y";
        body.request.payload.posvRefNumber = proposalNo;
        body.request.header.jwtToken = jwtToken;
        try {
            const response = await axios.post(url, body);
            console.log({ response });
            setOtpSentCount(otpSentCount + 1);
            setJwtToken(response?.data?.response?.header?.jwtToken)
            if (response?.data?.response?.msgInfo?.msgCode === "200") {
                setOtpSentMsg(response?.data?.response?.payload?.levelMessage ?? response?.data?.response?.payload?.businessMsg);
                setOtpSent(true);
                setCountdown(59);
                setStartCountdown(true);
            } else {
                setSendOtpError(response?.data?.response?.payload?.businessMsg ?? "Something went wrong.");
                setCountdown(59);
                setStartCountdown(true)
            }
        } catch (error) {
            console.log({ error });
            setSendOtpError("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const validateOtp = async () => {
        setVerifyOtpError('');
        const { url, body } = getApiData("soaValidateOtpApi");
        body.request.payload.otp = otp;
        body.request.header.jwtToken = jwtToken;

        try {
            setLoading(true);
            const response = await axios.post(url, body);
            setJwtToken(response?.data?.response?.header?.jwtToken)
            if (response?.data?.response?.messageInfo?.msgCode === "200") {
                setShowOtpPage(false)
            } else {
                setVerifyOtpError(response?.data?.response?.payload?.businessMsg);
            }
        } catch (error) {
            console.log({ error });
            setVerifyOtpError("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <DotsLoader msg={"Please wait..."} />
    }

    return (
        <div className='policy_pack_cntnr link_view_otp_verification'>
            <div className='policy_pack_form'>
                <div className='policy_pack_heading link_view_otp_verification'>
                    <h3>Enter OTP</h3>
                    {otpSent && <p>{otpSentMsg}</p>}
                    {sendOtpError && <p>{sendOtpError}</p>}
                </div>
                <div className='pp-from'>
                    {
                        otpSentCount === GENERATE_OTP_ATTEMPTS_ALLOWED ? <>
                            <p className='small-txt'>You have exceeded all your attempts to receive OTP, please contact the helpdesk No. 1800 121 8143/ 1800 102 8672</p>
                        </> : <p className='resend-otp'>Didn’t receive the OTP?{" "}
                            {
                                countdown > 0 ? (
                                    <span className='resend_txt_link_view'>Resend in{" "}
                                        <span className='resend_timer_link_view'>00:{countdown < 10 ? `0${countdown}` : countdown}s</span>
                                    </span>
                                ) : <span
                                    className='link_view_resend_otp_btn'
                                    onClick={getOtp}
                                >
                                    Resend OTP
                                </span>

                            }
                        </p>
                    }
                    <TextField
                        id="otp"
                        label="6 Digit OTP"
                        type="number"
                        className="new-ui-txt-field"
                        autoComplete="off"
                        variant="outlined"
                        fullWidth
                        value={otp}
                        onChange={(e) => (e.target.value.length <= 6) && setOtp(e.target.value)}
                        error={verifyOtpError?.length > 0}
                        onKeyDown={allowOnlyNumbers}
                    />
                    {verifyOtpError && <p className='pp-otp-msg'>{verifyOtpError}</p>}
                    <div className='button_div_unified'>
                        <Button
                            onClick={validateOtp}
                            // className='pp-submit-btn'
                            disabled={otp.length !== 6}
                            buttonType='primary'
                            size='default'
                        >
                            Verify OTP
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SDOtp;